import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import BlogCard from "./BlogCard";
import blogclient from "@serie3/common/api/blogClient";
import Header from "../frontend/Landingpage/Subcomponents/Header";
import { useTranslation } from "react-i18next";

const BlogList = ({ currentLanguage, setCurrentLanguage }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await blogclient.get();
        if (response.status === 200) {
          setBlogPosts([...response.data.subpages]);
        }
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  return (
    <>
      <Header currentLanguage={currentLanguage} setCurrentLanguage={setCurrentLanguage}>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <span className="section-label">{t("Landingpage.Blog.Label") || "Resources"}</span>
          <h1 className="heroHeader" style={{ marginTop: 12 }}>{t("Blog.Title") || "Blog"}</h1>
        </div>
      </Header>
      <Container style={{ marginBottom: 120 }}>
        {loading ? (
          <Row>
            {[1, 2, 3].map((i) => (
              <Col md={4} key={i} className="mb-3">
                <div style={{ borderRadius: 18, border: "1px solid #eaecf0", padding: 24, background: "#fff" }}>
                  <div className="lp-skeleton" style={{ height: 180, borderRadius: 10, marginBottom: 16 }} />
                  <div className="lp-skeleton" style={{ height: 22, width: "70%", borderRadius: 6, marginBottom: 10 }} />
                  <div className="lp-skeleton" style={{ height: 14, width: "90%", borderRadius: 6, marginBottom: 6 }} />
                  <div className="lp-skeleton" style={{ height: 14, width: "60%", borderRadius: 6 }} />
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            {blogPosts.map((post, index) => (
              <BlogCard size={4} post={post} key={index} />
            ))}
          </Row>
        )}
      </Container>
    </>
  );
};

export default BlogList;
